import React, { Component } from 'react';
import FieldModal from '../../../components/modals/fieldModal';

class DeleteRegistrantsModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isDeleting: false,
			deleteComplete: false
		};
	}

	deleteRegistrants = async () => {
		const { count } = this.props;
		
		this.setState({ isDeleting: true });
		
		// Simulate deletion process
		setTimeout(() => {
			this.props.delete();
			this.setState({ deleteComplete: true });
		}, 1000);
	};

	render() {
		const { isOpen, count, toggle } = this.props;
		const { isDeleting, deleteComplete } = this.state;

		return (
			<div>
				<FieldModal
					size="small"
					isOpen={isOpen}
					modalTitle={`Delete ${count > 1 ? 'Registrants' : 'Registrant'}`}
					bodyHeaderText={!isDeleting ? 
						<span>
							You are about to delete{' '}
							<b>
								{count} {count > 1 ? 'registrants' : 'registrant'}
							</b>
							. This action cannot be undone. The registrant{count > 1 ? 's' : ''} will be permanently removed 
							from your booking page, but their booking history will remain in the requests.
						</span> : null
					}
					bodyContent={() => {
						return (
							<div>
								{deleteComplete && <p>Complete</p>}
								{isDeleting && !deleteComplete && (
									<div>
										Deleting {count} {count > 1 ? 'registrants' : 'registrant'}...
									</div>
								)}
							</div>
						)
					}}
					toggle={toggle}
					actionButtonLabel={!isDeleting ? 'Delete' : deleteComplete ? null : 'Deleting...'}
					actionButton={() => this.deleteRegistrants()}
					isDelete={true}
					actionButtonDisabled={isDeleting}
					cancelButtonLabel={deleteComplete ? 'Close' : 'Cancel'}
				/>
			</div>
		);
	}
}

export default DeleteRegistrantsModal;
